module.exports = __webpack_public_path__ + "static/img/arrow.1604272.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/arrow.png
// module id = hYIH
// module chunks = 36